/**
 * @Author:
 * @Description:
 * @DateTime: Created in 18:32 2020/10/9
 */
import iView from 'lb-iview'

let IView: any = iView

IView.InputNumber.computed.precisionValue = function () {

		return  this.currentValue;

}

export default IView
